import { Component, OnInit } from '@angular/core';

import * as Chartist from 'chartist';
import { Router } from '@angular/router';
import { HttpService } from './../../shared/providers/http.service';
import { SessionService } from '@app-providers/session.service';
import { Role } from '@app-models/role.model';
import { User } from '@app-models/user.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {
    isLoading: boolean;
    home = '/dashboard';
    allRight: boolean;
    droit: User.Droit;
    documentNeedSetting: boolean;
    equipmentNeedSetting: boolean;
    travailleurNeedSetting: boolean;
    documentPametrageRoute: Array<string>;
    equipementPametrageRoute: Array<string>;
    travailleurPametrageRoute: Array<string>;
    constructor(
        private _httpService: HttpService,
        private _sessionService: SessionService,
        private _router: Router
    ) {
      this.documentNeedSetting = false;
      this.equipmentNeedSetting = false;
      this.travailleurNeedSetting = false;
      this.droit = this._sessionService.user.droit;
      this.allRight = (this._sessionService.user.role as Role).type === 'exploitant' || (this.droit && this.droit.admin);
    }

    async ngOnInit() {
      /*if ((this._sessionService.user.role as Role).type === 'exploitant') {
      } else {
        this._router.navigate([this.home]);
      }*/
      this.loadData();
    }

    async loadData() {
        this.isLoading = true;
        try {
          let {
            documentsGenerauxConforme,
            documentsGenerauxACorriger,
            documentsGenerauxCritique,
            documentsGenerauxNonSuivi,
            documentsGenerauxNonParametre,
            equipementsConforme,
            equipementsACorriger,
            equipementsCritique,
            equipementsNonSuivi,
            travailleursConforme,
            travailleursACorriger,
            travailleursCritique,
            travailleursNonParametre
          } = await this._httpService.get('users-permissions/stats').toPromise();
          if (
            !this._sessionService.company.siret
            ) {
              this._router.navigate(['/administration']);
            }

          // Documents généraux site //
          let totDocs = documentsGenerauxConforme + documentsGenerauxACorriger + documentsGenerauxCritique + documentsGenerauxNonSuivi;
          this.documentPametrageRoute = (this.allRight || this.droit.documentsGenerauxParametrage) ?
          ['/documents', 'setting'] : ['/documents', 'vue'];
          let arrDocs = [
            {value: this.calc(documentsGenerauxConforme, totDocs), className: 'pie-success',
             route: [['/documents', 'vue'],  {aCorriger: false, critique: false, conforme: true}]},
            {value: this.calc(documentsGenerauxACorriger, totDocs), className: 'pie-warning',
            route: [['/documents', 'vue'], {aCorriger: true, critique: false, conforme: false}]},
            {value: this.calc(documentsGenerauxCritique, totDocs), className: 'pie-danger',
            route:  [['/documents', 'vue'], {aCorriger: false, critique: true, conforme: false}]},
            {value: this.calc(documentsGenerauxNonSuivi, totDocs), className: 'pie-dark',
            route: [[...this.documentPametrageRoute], null]},
          ];
          let dataDocuments = {
            labels: [],
            series: []
          };

          if (totDocs === 0) {
            this.documentNeedSetting = true;
            dataDocuments.labels.push('Aucune donnée');
            dataDocuments.series.push({value: 100, className: 'pie-empty' });
          } else {
            for (let i of arrDocs) {
              if (i.value > 0) {
                dataDocuments.labels.push(`${i.value}%`);
                const {value, route, className} = i;
                dataDocuments.series.push({value, className, route });
              }
            }
          }

          // Equipements et installations //
          let totEquip = equipementsConforme + equipementsACorriger + equipementsCritique + equipementsNonSuivi;
          this.equipementPametrageRoute = (this.allRight || this.droit.equipementsInstallationsParametrage) ?
            ['/equipements', 'setting'] : ['/equipements', 'vue'];
          let arrEquip = [
            {value: this.calc(equipementsConforme, totEquip), className: 'pie-success',
             route: [['/equipements', 'vue'],  {aCorriger: false, critique: false, conforme: true}]},
            {value: this.calc(equipementsACorriger, totEquip), className: 'pie-warning',
            route: [['/equipements', 'vue'], {aCorriger: true, critique: false, conforme: false}]},
            {value: this.calc(equipementsCritique, totEquip), className: 'pie-danger',
            route:  [['/equipements', 'vue'], {aCorriger: false, critique: true, conforme: false}]},
            {value: this.calc(equipementsNonSuivi, totEquip), className: 'pie-dark',
            route: [[...this.equipementPametrageRoute], null]},
          ];

          let dataEquipements = {
            labels: [],
            series: []
          };

          if (totEquip === 0) {
            this.equipmentNeedSetting = true;
            dataEquipements.labels.push('Aucune donnée');
            dataEquipements.series.push({value: 100, className: 'pie-empty' });
          } else {
            for (let i of arrEquip) {
              if (i.value > 0) {
                dataEquipements.labels.push(`${i.value}%`);
                const {value, route, className} = i;
                dataEquipements.series.push({value, className, route });
              }
            }
          }

          // Travailleurs //
          let totTrav = travailleursConforme + travailleursACorriger + travailleursCritique + travailleursNonParametre;
          this.travailleurPametrageRoute = (this.allRight || this.droit.equipementsInstallationsParametrage) ?
          ['/travailleurs', 'parametrage'] : ['/travailleurs'];
          let arrTrav = [
            {value: this.calc(travailleursConforme, totTrav), className: 'pie-success',
            route:  [['/travailleurs'],  {aCorriger: false, critique: false, conforme: true}]},
            {value: this.calc(travailleursACorriger, totTrav), className: 'pie-warning',
            route:  [['/travailleurs'],  {aCorriger: true, critique: false, conforme: false}]},
            {value: this.calc(travailleursCritique, totTrav), className: 'pie-danger',
            route:  [['/travailleurs'],  {aCorriger: false, critique: true, conforme: false}]},
            {value: this.calc(travailleursNonParametre, totTrav), className: 'pie-dark',
            route:  [[...this.travailleurPametrageRoute],  null]},
          ];

          let dataTravailleurs = {
            labels: [],
            series: []
          };

          if (totTrav === 0) {
            this.travailleurNeedSetting = true;
            dataTravailleurs.labels.push('Aucune donnée');
            dataTravailleurs.series.push({value: 100, className: 'pie-empty' });
          } else {
            for (let i of arrTrav) {
              if (i.value > 0) {
                dataTravailleurs.labels.push(`${i.value}%`);
                dataTravailleurs.series.push({value: i.value, className: i.className, route: i.route})
              }
            }
          }

          const optionsPreferences = {
            height: '230px'
          };

          if ((this.allRight || this.droit.documentsGenerauxUtilisation) && !this.documentNeedSetting) {
            const docChart = new Chartist.Pie('#chart1', dataDocuments, optionsPreferences);
            docChart.on('draw', (data) => {
              data.element._node.onclick = event => this._router.navigate(data.series.route[0], {queryParams: data.series.route[1]});
            });
          }
          if ((this.allRight || this.droit.equipementsInstallationsUtilisation) && !this.equipmentNeedSetting) {
            const equipmentDoc = new Chartist.Pie('#chart2', dataEquipements, optionsPreferences);
            equipmentDoc.on('draw', (data) => {
              data.element._node.onclick = event => this._router.navigate(data.series.route[0], {queryParams: data.series.route[1]});
            });
          }
          if ((this.allRight || this.droit.travailleursUtilisation) && !this.travailleurNeedSetting) {
            const travDoc = new Chartist.Pie('#chart3', dataTravailleurs, optionsPreferences);
            travDoc.on('draw', (data) => {
              data.element._node.onclick = event => this._router.navigate(data.series.route[0], {queryParams: data.series.route[1]});
            });
          }

          this.isLoading = false;
        } catch (e) {
          this.isLoading = false;
          console.error(e);
        }
    }
    calc(i, total) {
      return Math.round((i * 100 ) / total);
    }
}
